module.exports = __webpack_public_path__ + "img/1592360109.082710c6.jpg";